
const clientId = 'ANIO'
const appUuid = 'Anio2-Frontend'

export class Http {

	/**
	 * Simple Http request
	 * @param path
	 * @param method
	 * @param body
	 */
	public static send(path: string, method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH" = "GET", body?: Object): Promise<any> {
		let options: RequestInit = {
			method: method,
			headers: { 'Content-Type': 'application/json', 'client-id': clientId, 'app-uuid': appUuid },
			body: body ? JSON.stringify(body) : undefined
		}
		let root = localStorage.getItem('persist:root');
		if (root) {
			let token = JSON.parse(JSON.parse(root).session).token
			if (token) {
				options.headers = { ...options.headers, 'Authorization': `Bearer ${token}` }
			}
		}
		return new Promise((resolve, reject) => {
			fetch(path, options)
				.then(response => {
					return response.status === 204 ? Promise.resolve(null) : response.json()
				})
				.then(resolve).catch(reject)
		})
	}
}
